export const formatVehicleFilter = (status, type) => ({
  filterStatus: Object.keys(status).filter(key => !status[key].isHide && status[key].isActive).map(key => key),
  filterType: Object.keys(type).filter(key => !type[key].isHide && type[key].isActive).map(key => key),
});
